import React, { useEffect, useState } from 'react';
import { map } from 'rxjs/operators';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getPersonRegistrationAutoCompleteApi, getPiRegistrationTypeApi } from 'actions/irb';

import TypeAhead from './TypeAhead';

const regPiStatus = ['Active', 'Suspended'];

export const fetchData = (context, getAutoCompleteAction, isInstitution, searchText) => {
  const getOptions = (response) => response.map((r) => {
    if (isInstitution) {
      const { siteCtepId, siteName } = r;
      return {
        label: `${siteCtepId} - ${siteName}`,
        value: siteCtepId,
        siteName
      };
    }
    return {
      label: r,
      value: r
    };
  });
  return bindLogger(
    getAutoCompleteAction,
    context
  )(searchText).pipe(
    map((resp) => {
      const { response } = resp;
      if (response != null && response.length > 0) {
        return getOptions(response);
      }
      return [];
    })
  );
};

/**
 * 1. If protocol number provided then, an API will be triggered to get registration type.
 * 2. If no protocol provided then registration type will not be fetched.
 * Registration type value will be sent for type ahead API call.
 * 
 * Protocol number is mandatory if its PI type ahead.
 * if not then its considered as person type ahead.
 * @param {string} protocolNumber 
 * @returns 
 */
function PersonTypeAhead({
  context, onChange, value, protocolNumber, ...rest
}) {
  const [piOptions, setPiOptions] = useState();
  const [registrationType, setRegistrationType] = useState(null);
  // reg type is empty and protocol number exists then isPiTypeAheadError will be true.
  // isPiTypeAheadError is used only for pi typeahead
  const isPiTypeAheadError = !registrationType && protocolNumber;

  useEffect(() => {
    if (protocolNumber) {
      bindLogger(getPiRegistrationTypeApi, context)(protocolNumber).subscribe((res) =>{
        setRegistrationType(res.response);
      })
    }
  }, [protocolNumber, context])

  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setPiOptions([]);
      return;
    }
    // dont call the api for pitypeahead if reg type is empty.
    if (isPiTypeAheadError) {
      return;
    }
    // proceed to api call to get dropdown values, 
    const actualFil = [
      {
        field: 'accountName',
        operation: 'contains',
        value: searchText
      }
    ];
    const regFilters = [
      ...actualFil,
      { field: 'registrationType', operation: 'contains', value: registrationType ? registrationType.toString() : '' },
      { field: 'registrationStatus', operation: 'contains', value: regPiStatus.toString() }
    ];
    const extraFilter = registrationType ? regFilters : actualFil;
    const postBody = {
      filter: extraFilter,
      first: 0,
      isMetaRequired: true,
      size: 50
    };
    bindLogger(
      getPersonRegistrationAutoCompleteApi,
      context
    )(postBody)().subscribe((resp) => {
      const { response } = resp;
      let options = [];
      if (response != null && response.length > 0) {
        if (registrationType) {
          options = response.map((obj) => {
            const val = obj.value;
            const [name, id, type, status] = val.split('|');
            return {
              label: val.trim(),
              value: id.trim(),
              personName: name.trim(),
              type: type.trim(),
              status: status.trim()
            };
          });
        } else {
          options = response.map((obj) => {
            const personName = obj.value.split('|');
            return {
              label: `${personName[0]} | ${personName[1].trim()}`,
              value: personName[1].trim()
            };
          });
        }
      }
      setPiOptions(options);
    });
  };

  return (
    <>
      <TypeAhead
        name="Person"
        value={value}
        options={piOptions}
        onChange={onChange}
        {...rest}
        onChangeText={fetchOptions}
      />
      {isPiTypeAheadError ? (
        <div className="form-layout-message-error">
          Site Protocol PI is not setup for {protocolNumber} protocol
        </div>
      ) : null}
    </>
  );
}

export default withAppContext(PersonTypeAhead);
